import { render, staticRenderFns } from "./CategorySpBackButton.vue?vue&type=template&id=11d45541&scoped=true&"
import script from "./CategorySpBackButton.vue?vue&type=script&lang=js&"
export * from "./CategorySpBackButton.vue?vue&type=script&lang=js&"
import style0 from "./CategorySpBackButton.vue?vue&type=style&index=0&id=11d45541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d45541",
  null
  
)

export default component.exports